import { common } from '@constants';

const setToken = token => localStorage.setItem(common.TOKEN, token);

const getToken = () => localStorage.getItem(common.TOKEN);

const removeToken = () => localStorage.removeItem(common.TOKEN);

const clear = () => localStorage.clear();

export default {
  setToken,
  getToken,
  removeToken,
  clear,
};
